import { defineMessages } from "react-intl";
const messages = defineMessages({
    title: {
        id: "app.aiDiscoverability.common.downloadReportDialog.title",
        defaultMessage: "Download Reports",
    },
    titleSingle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.titleSingle",
        defaultMessage: "Download Report",
    },
    selectCommunities: {
        id: "app.aiDiscoverability.common.downloadReportDialog.selectCommunities",
        defaultMessage: "Select communities to export",
    },
    communitiesSelected: {
        id: "app.aiDiscoverability.common.downloadReportDialog.communitiesSelected",
        defaultMessage: "({count}) Communities selected",
    },
    searchCommunity: {
        id: "app.aiDiscoverability.common.downloadReportDialog.searchCommunity",
        defaultMessage: "Search Community",
    },
    selectFormat: {
        id: "app.aiDiscoverability.common.downloadReportDialog.selectFormat",
        defaultMessage: "Select Format",
    },
    csvTitle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.csvTitle",
        defaultMessage: "CSV",
    },
    csvDescription: {
        id: "app.aiDiscoverability.common.downloadReportDialog.csvDescription",
        defaultMessage: "All raw data (sources + topics) and recommendations per selected community formatted on a spreadsheet.",
    },
    csvDescriptionSingle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.csvDescriptionSingle",
        defaultMessage: "All raw data (sources + topics) and recommendations for this report, formatted on a spreadsheet.",
    },
    zippedPdfTitle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.zippedPdfTitle",
        defaultMessage: "Zipped PDF reports",
    },
    zippedPdfDescription: {
        id: "app.aiDiscoverability.common.downloadReportDialog.zippedPdfDescription",
        defaultMessage: "One PDF per community, bundled in a .zip. All pages and their datasets included, formatted as seen on screen.",
    },
    pdfTitleSingle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.pdfTitleSingle",
        defaultMessage: "PDF report",
    },
    pdfDescriptionSingle: {
        id: "app.aiDiscoverability.common.downloadReportDialog.pdfDescriptionSingle",
        defaultMessage: "A single PDF with all pages and their datasets, formatted as seen on screen.",
    },
    cancel: {
        id: "app.aiDiscoverability.common.downloadReportDialog.cancel",
        defaultMessage: "Cancel",
    },
    download: {
        id: "app.aiDiscoverability.common.downloadReportDialog.download",
        defaultMessage: "Download",
    },
    selectOrganization: {
        id: "app.aiDiscoverability.common.downloadReportDialog.selectOrganization",
        defaultMessage: "Select Organization",
    },
    organizationPlaceholder: {
        id: "app.aiDiscoverability.common.downloadReportDialog.organizationPlaceholder",
        defaultMessage: "Select an organization",
    },
    communitiesLoading: {
        id: "app.aiDiscoverability.common.downloadReportDialog.communitiesLoading",
        defaultMessage: "Loading communities…",
    },
});
export default messages;
